import Vue from "vue";
import "./helper/registerElementComponents.js";

import MetaInfo from "vue-meta-info";

import App from "./App.vue";
import router from "./router";
import store from './store'
import "@/assets/style/reset.css";
import "@/assets/style/global.css";
// 注册自定义组件
import "@/helper/registerGlobalComponents.js";

// 富文本组件
import Editor from "@/components/Editor"

// 日期格式化过滤器

import { formatDate, handleTree } from "@/helper/utilities";

// 引入loading组件

import Loading from "@/components/Loading/main";
import PopupProgress from "@/components/popup-progress";
import Message from "@/components/message";

import scroll from "vue-seamless-scroll";

// 开发环境捕获错误插件

import NotificationPlugin from "./helper/notification.plugin";

if (process.env.NODE_ENV !== "production") {
  Vue.createElement = new Vue().$createElement;
  Vue.use(NotificationPlugin);
  Vue.config.devtools = true;
}


Vue.component('Editor', Editor)

// 使用loading 组件
Vue.use(Loading);
Vue.use(PopupProgress);
Vue.use(Message);
Vue.use(scroll);
Vue.use(MetaInfo);


// 注册日期格式化过滤器

Vue.filter("formatDate", formatDate);
Vue.prototype.handleTree = handleTree;

Vue.config.productionTip = false;

Vue.prototype.$scrollToTop = function () {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
};

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  }
}).$mount("#app");
